import { createSelector } from 'reselect';
import get from 'lodash/get';
import some from 'lodash/some';
import map from 'lodash/map';
import { SOCIAL_USER_PROFILE_UPDATE_SUCCESS } from 'action-creators/social/user/profile/update/constants';
import {
  COMPLETE_MY_INFO_PENDING,
  COMPLETE_MY_INFO_SUCCESS,
  COMPLETE_MY_INFO_ERROR,
} from 'actions/user';
import { USERTYPE } from '../actions/constantsActions';
import * as actions from '../action-creators/user';
import { LOCAL_STORAGE_USER_TOKEN } from 'constants.js';

const initialState = {
  user: {},
  info: null,
  profile: {},
  devices: [],
  loggedInProfile: null,
  paywayData: null,
  listPaymentMethod: null,
  rentHistory: [],
  userDataComplete: {},
  statusControlPin: null,
  pinParental: null,
  pinPurchase: null,
  statusPinCodeSet: null,
  remindControlPin: null,
  devicesByPurchase: [],
  errorEmailExist: null,
  sendEmailConfirmControlPin: false,
  flowLoaded: false,
};

const ACTION_HANDLERS = {
  [USERTYPE]: (state, action) =>
    Object.assign({}, state, {
      ...state.user,
      ...action.user,
    }),

  CLEARUSER: (state, action) => action.user,

  [actions.CONST_SET_USER_MODIFY]: (state, action) => {
    const newUserInfo = state.info || {};
    newUserInfo.email = action.data.email || action.data.username;
    // update user data localstorge
    const userData = localStorage.getItem('loginInfo.logged_user_data');
    const userDataJson = JSON.parse(userData);
    userDataJson.username = action.data.email || action.data.username;
    userDataJson.firstname = action.data.firstname;
    userDataJson.lastname = action.data.lastname;
    localStorage.setItem(
      'loginInfo.logged_user_data',
      JSON.stringify(userDataJson),
    );

    return Object.assign({}, state, {
      info: newUserInfo,
      sendEmailConfirmControlPin: true,
      ...userDataJson,
    });
  },

  [actions.CONST_SET_ERROR_EMAIL_EXIST]: (state, action) =>
    Object.assign({}, state, {
      errorEmailExist: action.data,
    }),
  [COMPLETE_MY_INFO_PENDING]: state => ({
    ...state,
    userDataComplete: {
      loading: true,
    },
  }),
  [COMPLETE_MY_INFO_SUCCESS]: state => ({
    ...state,
    userDataComplete: {
      updated: true,
      loading: false,
    },
  }),
  [COMPLETE_MY_INFO_ERROR]: (state, action) => ({
    ...state,
    userDataComplete: {
      error: action.error,
    },
  }),
  [actions.IS_LOGGED_IN_PROFILE]: (state, action) => ({
    ...state,
    profile: action.profile,
  }),

  [actions.CARD_VIEW_SET_SEEN_LAST]: (state, action) => ({
    ...state,
    seenLast: action.seenLast,
  }),

  [actions.CONST_SET_INFO]: (state, action) =>
    Object.assign({}, state, { info: action.info }),

  [actions.CONST_SET_RENT_HISTORY]: (state, action) =>
    Object.assign({}, state, {
      rentHistory: action.rentHistory,
    }),

  [actions.CONST_SET_DEVICES]: (state, action) =>
    Object.assign({}, state, {
      devices: action.devices,
    }),

  [actions.CONST_DETACH]: (state, action) => {
    // lista dispositivos
    const devicesList = state.devices.filter(
      device => device.device_id != action.data.device_id,
    );
    //  lista de historial de dispositivos
    const devicesByPurchase = (state.devicesByPurchase || []).map(dev =>
      Object.assign(
        {},
        dev,
        dev.purchase_id == action.data.purchase_id
          ? {
              devices: dev.devices.filter(
                d => d.device_id != action.data.device_id,
              ),
            }
          : { devices: dev.devices },
      ),
    );

    return Object.assign({}, state, {
      devices: devicesList,
      devicesByPurchase,
    });
  },

  [SOCIAL_USER_PROFILE_UPDATE_SUCCESS]: (state, action) => {
    const loggedInProfile = Object.assign({}, state.loggedInProfile);
    loggedInProfile.isPrivate = action.payload;
    return Object.assign({}, state, {
      loggedInProfile,
    });
  },

  [actions.CONST_SET_SOCIAL_PROFILE]: (state, action) =>
    Object.assign({}, state, {
      loggedInProfile: action.profile,
    }),

  [actions.CONST_SET_PAYWAY_DATA]: (state, action) => {
    const { paywayData } = action;
    return Object.assign({}, state, { paywayData });
  },

  [actions.CONST_SET_PAYWAY_PROFILE]: (state, action) => {
    const { paywayProfile } = action;
    return Object.assign({}, state, { paywayProfile });
  },

  [actions.CONST_REMOVE_USER_SUSC]: (state, action) => {
    const data = state.paywayData.map(d =>
      Object.assign(
        {},
        d,
        d.purchase_data.purchase_id == action.purchase_id
          ? {
              purchase_data: Object.assign({}, d.purchase_data, {
                in_process_canceled: 1,
              }),
            }
          : { purchase_data: Object.assign({}, d.purchase_data, {}) },
      ),
    );
    return Object.assign({}, state, { paywayData: data });
  },

  [actions.CONST_SET_PAYWAY_LIST_PAYMENT_METHOD]: (state, action) =>
    Object.assign({}, state, {
      listPaymentMethod: action.listPaymentMethod,
    }),

  [actions.CONST_SET_STATUS_CONTROL_PIN]: (state, action) =>
    Object.assign({}, state, {
      statusControlPin: action.statusControlPin,
    }),

  [actions.CONST_SET_CONFIRM_CONTROL_PIN]: (state, action) =>
    Object.assign({}, state, {
      statusPinCodeSet: action.statusPinCodeSet,
    }),

  [actions.CONST_SET_REMIND_CONTROL_PIN]: (state, action) =>
    Object.assign({}, state, {
      remindControlPin: action.remindControlPin,
    }),

  [actions.CONST_REMOVE_REMIND_CONTROL_PIN]: state =>
    Object.assign({}, state, {
      remindControlPin: null,
    }),

  [actions.CONST_SET_UPDATE_CONTROL_PIN]: (state, action) => {
    const controlPin = state.statusControlPin;
    // status_parental y status_purchase viene del remove PIN∫
    controlPin.pin_parental.status =
      typeof action.data.status_parental_pin === 'number'
        ? action.data.status_parental_pin
        : action.data.pin_parental;
    controlPin.pin_purchase.status =
      typeof action.data.status_purchase_pin === 'number'
        ? action.data.status_purchase_pin
        : action.data.pin_purchase;

    if (controlPin.pin_parental.info) {
      controlPin.pin_parental.info.value = action.data.pin_ratings;
      controlPin.pin_parental.info.name = action.data.name;
    }

    return Object.assign({}, state, { statusControlPin: controlPin });
  },

  [actions.CONST_SET_DEVICES_BY_PURCHASE_ID]: (state, action) => {
    const devices = action.devices || [];
    if (devices.length < 1) {
      return state;
    }

    return Object.assign({}, state, {
      devicesByPurchase: state.devicesByPurchase.concat(action.devices),
    });
  },

  [actions.CONST_SET_NEW_USER_NAME]: (state = initialState, action) => {
    const userData = localStorage.getItem('loginInfo.logged_user_data');
    const userDataJson = JSON.parse(userData);

    userDataJson.firstname = action.data.firstname;
    userDataJson.lastname = action.data.lastname;
    const stringData = JSON.stringify(userDataJson);
    localStorage.setItem('loginInfo.logged_user_data', stringData);
    localStorage.setItem(LOCAL_STORAGE_USER_TOKEN, userDataJson?.token);
    return Object.assign({}, state, action.data);
  },

  [actions.CONST_SET_TERMS_AND_CONDITIONS]: (state = initialState, action) => {
    const acceptTerms = Number(action.acceptTerms);
    const userData = localStorage.getItem('loginInfo.logged_user_data');
    const userDataJson = JSON.parse(userData);

    userDataJson.acceptTerms = acceptTerms;
    const stringData = JSON.stringify(userDataJson);

    localStorage.setItem('loginInfo.logged_user_data', stringData);
    localStorage.setItem(LOCAL_STORAGE_USER_TOKEN, userDataJson?.token);
    localStorage.setItem('loginInfo.acceptedTerms', String(acceptTerms));
    return {
      ...state,
      acceptTerms: action.acceptTerms,
    };
  },

  [actions.CONST_SET_USER_TYPE_LITE]: (state = initialState, action) => {
    return {
      ...state,
      userTypeLite: action.userTypeLite,
    };
  },

  [actions.CONST_SET_USER_TOKEN]: (state = initialState, action) => {
    return {
      ...state,
      token: action?.userToken,
    };
  },

  [actions.CONST_UPDATE_NEW_SESSION]: (state = initialState, action) => {
    const { userData } = action;

    return {
      ...state,
      token: userData.user_token,
      session_stringvalue: userData.session_stringvalue,
      userhash: userData.session_userhash,
    };
  },
  [actions.SET_USER_SUBSCRIPTIONS]: (state=initialState, action) => {
    return {
      ...state,
      subscriptions: action.payload
    }
  }
};

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

/**
 * @deprecated since version 3.97.
 *  use the selectors of the following file
 *  src/react/reducers/selectors/user.js
 */
export const getUserState = state => get(state, 'user');

export const getControlPin = createSelector(
  [getUserState],
  user => get(user, 'statusControlPin'),
);

export const getPinPurchase = createSelector(
  [getControlPin],
  controlPin => get(controlPin, ['pin_purchase', 'status'], 0),
);

export const getPinParental = createSelector(
  [getControlPin],
  controlPin => get(controlPin, ['pin_parental', 'status'], 0),
);

export const getPinChannel = createSelector(
  [getControlPin],
  controlPin => get(controlPin, ['pin_channel', 'status'], 0),
);
export const getRatingValue = createSelector(
  [getControlPin],
  controlPIN => get(controlPIN, ['pin_parental', 'info', 'value'], 20),
);

export const getPINs = createSelector(
  [getPinPurchase, getPinParental, getPinChannel],
  (pin_purchase, pin_parental, pin_channel) => ({
    pin_purchase,
    pin_parental,
    pin_channel,
  }),
);

export const getBooleanPins = createSelector(
  [getPINs],
  pins => map(pins, (value, key) => ({ [key]: !!+value })),
);

export const getPINSforActivate = createSelector(
  [getPinPurchase, getPinParental, getPinChannel],
  (status_purchase_pin, status_parental_pin, status_channel_pin) => ({
    status_purchase_pin,
    status_parental_pin,
    status_channel_pin,
  }),
);

export const getBooleanPinsForActivate = createSelector(
  [getPINSforActivate],
  pins => map(pins, (value, key) => ({ [key]: !!+value })),
);

export const hasPinEnabled = createSelector(
  [getBooleanPins],
  pins => some(pins),
);

export const getUserHash = createSelector(
  [getUserState],
  user => get(user, 'userhash'),
);

export const getUserID = createSelector(
  [getUserState],
  user => get(user, 'user_id'),
);

export const getUserEmail = createSelector(
  [getUserState],
  user => get(user, 'username'),
);

export const getUserFirstName = createSelector(
  [getUserState],
  user => get(user, 'firstname'),
);

export const getUserLastName = createSelector(
  [getUserState],
  user => get(user, 'lastname'),
);

export const getUserProfile = createSelector(
  [getUserState],
  user => get(user, 'profile'),
);

export const getListPaymentMethod = createSelector(
  [getUserProfile],
  profile => get(profile, 'paymentMethods'),
);

function transformArrayToObjectKeys(array, keys) {
  return array.reduce(
    (objectKey, data, index) => ({ ...objectKey, [keys[index]]: data }),
    {},
  );
}

export const getListPaymentMethodWithoutDisabled = createSelector(
  [getListPaymentMethod],
  (paymentMethods = []) =>
    paymentMethods.filter(paymentMethod => paymentMethod.status !== 'DISABLED'),
);

export const getUserDataToClaroPagos = createSelector(
  [
    getUserID,
    getUserFirstName,
    getUserLastName,
    getUserEmail,
    getListPaymentMethodWithoutDisabled,
  ],
  (...user) =>
    transformArrayToObjectKeys(user, [
      'userId',
      'firstName',
      'lastName',
      'email',
      'listPaymentMethod',
    ]),
);

export const getUserToken = createSelector(
  [getUserState],
  user => get(user, 'token'),
);

export const getRegion = createSelector(
  [getUserState],
  user => get(user, 'region'),
);

export const getStatusPurchasePin = state =>
  get(state, 'cvControlPin.initial.pin_purchase.status', 0);
